const REFERENCE_ASSETS = require('../reference-assets.js');
const coins = require('../coins');

module.exports = [
  {
    dataIndex: 0,
    id: 'aave',
    name: 'aave',
    lpTokenInfo: {
        name: 'aaveCurve',
        symbol: 'a3Crv',
    },
    coingeckoInfo: {
        id: 'aave',
        symbol: 'AAVE',
    },
    assets: 'aDAI+aUSDC+aUSDT',
    coins: [
        coins.adai,
        coins.ausdc,
        coins.ausdt,
    ],
    underlyingCoins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    isLendingPool: true,
    isModernLendingPool: true,
    addresses: {
        swap: '0x445FE580eF8d70FF569aB36e80c647af338db351',
        lpToken: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171',
        gauge: '0x19793B454D3AfC7b454F206Ffe95aDE26cA6912c',
        old_gauge: '0xe381C25de995d62b453aF8B931aAc84fcCaa7A62'
    },
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [{
        key: 'CRV3POOL',
        name: 'CRV',
        amountDataKey: 'crvRewards3Pool',
        rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0xC48f4653dd6a9509De44c92beb0604BEA3AEe714'
    },{
        key: 'WMATIC3POOL',
        name: 'WMATIC',
        rewardTokenCoingeckoId: 'matic-network',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
        rewardContract: '0xC48f4653dd6a9509De44c92beb0604BEA3AEe714'
    }],
    hasNoCRVRewards: true,
  },
  {
  dataIndex: 1,
  id: 'atricrypto',
  name: 'atricrypto',
  lpTokenInfo: {
      name: '3CrvCrypto',
      symbol: '3CrvCrypto',
  },
  assets: 'adai+ausdc+ausdt+aeth+abtc',
  coins: [
      coins.dai,
      coins.usdc,
      coins.usdt,
      coins.wbtc,
      coins.weth,
  ],
  addresses: {
      swap: '0x751B1e21756bDbc307CBcC5085c042a0e9AaEf36',
      lpToken: '0x8096ac61db23291252574D49f036f0f9ed8ab390',
      deposit: '0x3FCD5De6A9fC8A99995c406c77DDa3eD7E406f81',
      gauge: '0xb0a366b987d77b5eD5803cBd95C80bB6DEaB48C0',
      migrator: '0xAf0B9422eFFB6941B9D79FdE5576Ea2F8AF046E4',
  },
  cryptoPool: true,
  referenceAsset: REFERENCE_ASSETS.CRYPTO,
  isFakePlainPool: true,
  gaugeVersion: 3, // No CRV rewards
  oldAdditionalRewards: [{
      key: 'CRVATRICRYPTO',
      name: 'CRV',
      amountDataKey: 'crvRewardsaTriCrypto',
      rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
      rewardTokenDecimals: 18,
      rewardTokenCoingeckoId: 'curve-dao-token',
      rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
  },{
      key: 'WMATICATRICRYPTO',
      name: 'WMATIC',
      amountDataKey: 'maticRewards',
      rewardTokenCoingeckoId: 'matic-network',
      rewardTokenDecimals: 18,
      rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
      rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
  }],
  hasNoCRVRewards: true,

}, {
  dataIndex: 2,
  id: 'ren',
  name: 'ren',
  lpTokenInfo: {
      name: 'renCurve',
      symbol: 'renCrv',
  },
  coingeckoInfo: {
      id: 'renbtc',
      symbol: 'RENBTC',
      referenceAssetId: 'bitcoin',
  },
  assets: 'awBTC+renBTC',
  coins: [
      coins.amwbtc,
      coins.renbtc
  ],
  underlyingCoins: [
      coins.wbtc,
      coins.renbtc
  ],
  isLendingPool: true,
  referenceAsset: REFERENCE_ASSETS.BTC,
  isModernLendingPool: true,
  addresses: {
      swap: '0xC2d95EEF97Ec6C17551d45e77B590dc1F9117C67',
      lpToken: '0xf8a57c1d3b9629b77b6726a042ca48990A84Fb49',
      gauge: '0xffbACcE0CC7C19d46132f1258FC16CF6871D153c',
      old_gauge: '0x93b14f53528a59e655d8ce39bdba443dcddddc4c'
  },
  gaugeVersion: 3, // No CRV rewards
  additionalRewards: [{
      key: 'CRVREN',
      name: 'CRV',
      amountDataKey: 'crvRewardsRen',
      rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
      rewardTokenDecimals: 18,
      rewardTokenCoingeckoId: 'curve-dao-token',
      rewardContract: '0x488E6ef919C2bB9de535C634a80afb0114DA8F62'
  },{
      key: 'WMATICREN',
      name: 'WMATIC',
      amountDataKey: 'maticRewards',
      rewardTokenCoingeckoId: 'matic-network',
      rewardTokenDecimals: 18,
      rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
      rewardContract: '0x488E6ef919C2bB9de535C634a80afb0114DA8F62'
  }],
  hasNoCRVRewards: true,

}, {
    dataIndex: 4,
    id: 'atricrypto2',
    name: 'atricrypto2',
    lpTokenInfo: {
        name: '3CrvCrypto2',
        symbol: '3CrvCrypto2',
    },
    assets: 'adai+ausdc+ausdt+aeth+abtc',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
        coins.wbtc,
        coins.weth,
    ],
    addresses: {
        swap: '0x92577943c7aC4accb35288aB2CC84D75feC330aF',
        lpToken: '0xbece5d20A8a104c54183CC316C8286E3F00ffC71',
        deposit: '0x3Fa8ebd5d16445b42e0b6A54678718C94eA99aBC',
        gauge: '0x9bd996Db02b3f271c6533235D452a56bc2Cd195a',
        migrator: '0x321CDba34da09Cf57C709F75DBb42bA209cFe6Ac'
    },
    cryptoPool: true,
    referenceAsset: REFERENCE_ASSETS.CRYPTO,
    isFakePlainPool: true,
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [],
    hasNoCRVRewards: true,
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [{
        key: 'CRVATRICRYPTO2',
        name: 'CRV',
        amountDataKey: 'crvRewardsaTriCrypto2',
        rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
    },{
        key: 'WMATICATRICRYPTO2',
        name: 'WMATIC',
        amountDataKey: 'maticRewards',
        rewardTokenCoingeckoId: 'matic-network',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
        rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
    }],
    hasNoCRVRewards: true,
}, {
    dataIndex: 5,
    id: 'atricrypto3',
    name: 'atricrypto3',
    lpTokenInfo: {
        name: '3CrvCrypto3',
        symbol: '3CrvCrypto3',
    },
    assets: 'adai+ausdc+ausdt+aeth+abtc',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
        coins.wbtc,
        coins.weth,
    ],
    addresses: {
        swap: '0x92215849c439E1f8612b6646060B4E3E5ef822cC',
        lpToken: '0xdAD97F7713Ae9437fa9249920eC8507e5FbB23d3',
        deposit: '0x1d8b86e3D88cDb2d34688e87E72F388Cb541B7C8',
        gauge: '0x3B6B158A76fd8ccc297538F454ce7B4787778c7C',
    },
    cryptoPool: true,
    referenceAsset: REFERENCE_ASSETS.CRYPTO,
    isFakePlainPool: true,
    basePoolId: 'aave',
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [],
    hasNoCRVRewards: true,
    additionalRewards: [{
        key: 'CRVATRICRYPTO3',
        name: 'CRV',
        amountDataKey: 'crvRewardsaTriCrypto3',
        rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
    },{
        key: 'WMATICATRICRYPTO3',
        name: 'WMATIC',
        amountDataKey: 'maticRewards',
        rewardTokenCoingeckoId: 'matic-network',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
        rewardContract: '0x060e386eCfBacf42Aa72171Af9EFe17b3993fC4F'
    }],
    hasNoCRVRewards: true,
},
{
    dataIndex: 6,
    id: 'eurtusd',
    name: 'eurtusd',
    referenceAsset: REFERENCE_ASSETS.CRYPTO,
    isForexMetaPool: true,
    lpTokenInfo: {
        name: 'eurtUsdCurve',
        symbol: 'eurtUsdCrv',
    },
    coingeckoInfo: {
        id: 'tether-eurt',
        symbol: 'EURt',
    },
    isMetaPool: true,
    cryptoPool: true,
    // isFakePlainPool: true,
    assets: 'EURt+a3pool',
    coins: [
        coins.eurt,
        coins.atricrv
    ],
    metaCoins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0xB446BF7b8D6D4276d0c75eC0e3ee8dD7Fe15783A',
        lpToken: '0x600743B1d8A96438bD46836fD34977a00293f6Aa',
        gauge: '0x40c0e9376468b4f257d15F8c47E5D0C646C28880',
        deposit: '0x225FB4176f0E20CDb66b4a3DF70CA3063281E855',
    },
    additionalRewards: [{
        key: 'CRVEURT',
        name: 'CRV',
        amountDataKey: 'crvRewards3Pool',
        rewardTokenAddress: '0x172370d5cd63279efa6d502dab29171933a610af',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0xAF78381216a8eCC7Ad5957f3cD12a431500E0B0D'
    }],
    gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true
}, {
    dataIndex: 6,
    id: 'eursusd',
    name: 'eursusd',
    referenceAsset: REFERENCE_ASSETS.CRYPTO,
    isForexMetaPool: true,
    lpTokenInfo: {
        name: 'eursUsdCurve',
        symbol: 'eursUsdCrv',
    },
    coingeckoInfo: {
        id: 'stasis-eurs',
        symbol: 'EURS',
    },
    isMetaPool: true,
    cryptoPool: true,
    // isFakePlainPool: true,
    assets: 'EURS+a3pool',
    coins: [
        coins.eurs,
        coins.atricrv
    ],
    metaCoins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x9b3d675FDbe6a0935E8B7d1941bc6f78253549B7',
        lpToken: '0x7BD9757FbAc089d60DaFF1Fa6bfE3BC99b0F5735',
        gauge: '0x40c0e9376468b4f257d15F8c47E5D0C646C28880', // Unrelated gauge address used as placeholder
        deposit: '0x4DF7eF55E99a56851187822d96B4E17D98A47DeD',
    },
    hasNoGauge: true,
}
];
